import { render, staticRenderFns } from "./ValidateRegistration.vue?vue&type=template&id=69813710&scoped=true"
import script from "./ValidateRegistration.vue?vue&type=script&lang=js"
export * from "./ValidateRegistration.vue?vue&type=script&lang=js"
import style0 from "./ValidateRegistration.vue?vue&type=style&index=0&id=69813710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69813710",
  null
  
)

export default component.exports